import useLocalStorage from "./useLocalStorage";
import { useEffect } from "react";

export enum OriginContext {
  PAYMENT = "PAYMENT",
}

const buildKeyName = (context: OriginContext) => {
  return `capitalise/origin-${context}`;
};

function useOrigin<T, S = {}>(
  context: OriginContext,
  initialOrigin?: T,
  initialMetadata?: S
) {
  const [origin, setOrigin] = useLocalStorage(
    buildKeyName(context),
    undefined
  ) as [
    { value: T; metadata: S },
    (valueMetadata: { value: T; metadata: S }) => void
  ];

  useEffect(() => {
    if (initialOrigin) {
      setOrigin({ value: initialOrigin, metadata: initialMetadata });
    }
  }, [initialOrigin]);

  const clearOrigin = () => {
    setOrigin({ value: undefined, metadata: undefined });
  };

  const { value, metadata } = origin || {};

  return { origin: value, metadata, setOrigin, clearOrigin };
}

export default useOrigin;
